const colors = {
    transparent: 'transparent',
    current: 'currentColor',
    black: '#000',
    white: '#fff',
    gray: {
        0: '#ffffff',
        50: '#f7f8fa',
        100: '#f0f2f5',
        150: '#dee4ec',
        200: '#ced8e3',
        250: '#b3bfcf',
        300: '#9aa8bb',
        350: '#828e9e',
        400: '#6b7582',
        450: '#5b646f',
        500: '#4c535d',
        550: '#383d45',
        600: '#25282d',
    },
    red: {
        100: '#fee2e8',
        200: '#fabcc8',
        300: '#fd94a9',
        400: '#fd4c6f',
        500: '#e02d52',
        600: '#a12e48',
        700: '#88152f',
    },
    orange: {
        100: '#feedde',
        200: '#ffc48c',
        300: '#f68d2e',
        400: '#db781c',
        500: '#b35f11',
        600: '#8c4400',
    },
    yellow: {
        100: '#fff7d9',
        200: '#ffe88c',
        300: '#ffcb00',
        400: '#d9ad00',
        500: '#b38f00',
        600: '#997a00',
    },
    green: {
        100: '#d9fff2',
        200: '#80ffd2',
        300: '#00cc85',
        400: '#00aa6e',
        500: '#008858',
        600: '#166549',
        700: '#184f3b',
    },
    blue: {
        100: '#d9e9ff',
        200: '#bfdaff',
        300: '#80b5ff',
        400: '#4090ff',
        500: '#006aff',
        600: '#004fbd',
        700: '#003989',
    },
    purple: {
        100: '#e6d9ff',
        200: '#d5bfff',
        300: '#ac80ff',
        400: '#9b66ff',
        500: '#7b44e4',
        600: '#6739bf',
    },
};
export default { ...colors, neutral: { ...colors.gray } };
//# sourceMappingURL=colors.js.map